import { render } from "./addToCalendarButton.vue?vue&type=template&id=f49530f4&ts=true"
import script from "./addToCalendarButton.vue?vue&type=script&lang=ts"
export * from "./addToCalendarButton.vue?vue&type=script&lang=ts"

import "./addToCalendarButton.vue?vue&type=style&index=0&id=f49530f4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__